module.exports = __webpack_public_path__ + "img/4.19feb4f3.jpg";